


































import {
  Vue,
  Component,
} from "@/shared/vuepack";

import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { UserTargeting } from "@/shared/types";

@Component({
  components: {}
})
export default class FlagListing extends Vue {
  featureFlagStore = useFeatureFlagStore();

  get userTargeting (): UserTargeting {
    return this.featureFlagStore.userContext;
  }

  get featureFlagsLoadedState (): boolean {
    return this.featureFlagStore.featureFlagsAvailable;
  }

  get featureFlagsTimedOutState (): boolean {
    return this.featureFlagStore.flagsTimedOut;
  }

  get flags () {
    return this.featureFlagStore.flags;
  }
}
